import { UPLOAD_IMAGE_PREVIEW_STATE } from './UploadImageModal.constants'

export function isUploadImagePreviewStateSkeleton(previewState) {
  return previewState === UPLOAD_IMAGE_PREVIEW_STATE.SKELETON
}

export function isUploadImagePreviewStateError(previewState) {
  return previewState === UPLOAD_IMAGE_PREVIEW_STATE.ERROR
}

export function isUploadImagePreviewStateLoading(previewState) {
  return previewState === UPLOAD_IMAGE_PREVIEW_STATE.LOADING
}
